export type ExploreOthersObject = {
  id: string;
  url: string;
  bgImg: string;
  displayText: string;
};

export const FIND_AGENCY: ExploreOthersObject = {
  id: 'find-a-commercial-agency',
  url: 'https://www.realcommercial.com.au/find-agent/',
  bgImg: '/listing-ui-assets/img/homepage/explore-others/find-agency',
  displayText: 'Find a commercial agency',
};

export const INVEST_PROPERTY: ExploreOthersObject = {
  id: 'invest-in-commercial-property',
  url: 'https://www.realcommercial.com.au/invest/',
  bgImg: '/listing-ui-assets/img/homepage/explore-others/invest',
  displayText: 'Invest in commercial property',
};

export const EXPLORE_LEASES: ExploreOthersObject = {
  id: 'explore-short-term-leases',
  url: 'https://www.realcommercial.com.au/short-term-workspace/',
  bgImg: '/listing-ui-assets/img/homepage/explore-others/short-term',
  displayText: 'Explore short-term leases',
};

export const CATCHUP_NEWS: ExploreOthersObject = {
  id: 'catch-up-on-the-latest-news',
  url: 'https://www.realcommercial.com.au/news/',
  bgImg: '/listing-ui-assets/img/homepage/explore-others/news',
  displayText: 'Read the latest commercial news',
};

export const DEFAULT_ITEMS: ExploreOthersObject[] = [
  FIND_AGENCY,
  INVEST_PROPERTY,
  EXPLORE_LEASES,
  CATCHUP_NEWS,
];
